import type mitt from 'mitt';
import type { PluginObject } from 'vue';

import NotificationsGroup from './NotificationsGroup.vue';

export interface NotificationData {
  group?: string
  duration?: number
  id?: string
  text: string
  type: 'error' | 'warning' | 'success' | 'info'
  data?: any
}

export type NotifyFunction = (data: NotificationData) => void;

const NotificationsPlugin: PluginObject<{ bus: ReturnType<typeof mitt> }> = {
  install(vue, options) {
    if (this.installed)
      return;
    if (!options)
      return import.meta.env.DEV && console.error('NotificationsPlugin', 'Bus mitt not found');

    const { bus } = options;

    const notify: NotifyFunction = (data) => {
      bus.emit('notification:push', data);
    };

    vue.prototype.$notify = vue.notify = notify;

    vue.component('NotificationsGroup', NotificationsGroup);

    this.installed = true;
  },
};

declare module 'vue/types/vue' {
  interface VueConstructor {
    notify: NotifyFunction
  }

  interface Vue {
    $notify: NotifyFunction
  }
}

export default NotificationsPlugin;
